import React, { Suspense, useEffect } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { useDispatch } from "react-redux";

import PrimarySearchAppBar from "./common/PrimarySearchAppBar";
import BookSearchResults from "./BookSearchResults";
import SearchBookLandingPage from "./staticComponents/SearchBookLandingPage";
import BookReadingPage from "./BookReadingPage";
import ReadingList from "./ReadingList";
import About from "./staticComponents/About";
import NotFoundPage from "./staticComponents/NotFoundPage";
import SignIn from "./loginPage/SignIn";
import history from "../router/history";
import theme from "../theme/theme";
import { auth } from "../firebase.config";
import {
  onSignIn,
  onSignOut,
  getUserReadingList,
  clearReadingList,
} from "../redux/actions";

//Material-UI
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import { ThemeProvider } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const unregisterAuthObserver = auth.onAuthStateChanged((user) => {
      if (user) {
        // User is signed in.
        dispatch(onSignIn(user));
        dispatch(getUserReadingList(user));
      } else {
        // User is signed out.
        dispatch(onSignOut());
        dispatch(clearReadingList());
      }
    });

    return function cleanup() {
      unregisterAuthObserver();
    };
  });

  return (
    <div>
      <Router history={history}>
        <CssBaseline />
        <ThemeProvider theme={theme}>
          <PrimarySearchAppBar />
          <Container maxWidth="lg">
            <Suspense
              fallback={
                <Backdrop open invisible>
                  <CircularProgress color="primary" />
                </Backdrop>
              }
            >
              <Switch>
                <Route path="/" exact component={SearchBookLandingPage} />
                <Route path="/SignIn" exact component={SignIn} />
                <Route
                  path="/Search/:query/:pageNumber"
                  exact
                  component={BookSearchResults}
                />
                <Route
                  path="/ReadingList/:bookId"
                  exact
                  component={BookReadingPage}
                />
                <Route path="/ReadingList" exact component={ReadingList} />
                <Route path="/About" exact component={About} />

                <Route component={NotFoundPage} />
              </Switch>
            </Suspense>
          </Container>
        </ThemeProvider>
      </Router>
    </div>
  );
}

export default App;
